import { FC } from "react";
import styles from "./NodeSelectorView.module.scss";

export interface NodeSelectorViewProps {
  PoleSelectorPresenter: FC;
  label?: string;
  variant?: "dark" | "light";
  isError?: boolean;
}

export default function NodeSelectorView({
  PoleSelectorPresenter,
  variant = "light",
  label,
  isError ,
}: NodeSelectorViewProps) {
  return (
    <div
      className={[
        styles["node-container"],
        styles["node-container--" + variant],
        isError ? styles["node-container--" + variant + "--error"] : "",
      ].join(" ")}
    >
      <span
        className={[
          styles["node-container__label"],
          styles["node-container__label--" + variant],
          isError
            ? styles["node-container__label--" + variant + "--error"]
            : "",
        ].join(" ")}
      >
        {label}
      </span>
      <div
        className={[
          styles["node-container__item"],
          styles["node-container__item--" + variant],
        ].join(" ")}
      >
        <PoleSelectorPresenter />
      </div>
    </div>
  );
}
